import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQ_ITEMS } from "../data/content";

const Faq = () => (
    <section id="faq" data-testid="faq-accordion-section" className="bg-heritage-cream py-24 md:py-36">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 md:px-10 lg:grid-cols-[1fr_1.6fr]">
            <Reveal>
                <Eyebrow>Questions, Answered</Eyebrow>
                <h2 className="mt-6 font-serif text-3xl font-medium leading-tight tracking-tight text-heritage-ink sm:text-4xl lg:text-5xl">
                    Frequently Asked <em className="text-heritage-terra">Questions</em>
                </h2>
                <p className="mt-7 max-w-md text-base leading-relaxed text-heritage-ink/70">
                    Everything visitors usually ask before visiting the Indian Heritage Cultural
                    Centre in George Town, Penang.
                </p>
            </Reveal>

            <Reveal delay={0.12}>
                <Accordion
                    type="single"
                    collapsible
                    data-testid="faq-accordion-list"
                    className="w-full"
                >
                    {FAQ_ITEMS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-heritage-terra/15"
                        >
                            <AccordionTrigger
                                data-testid={`faq-question-${i}`}
                                className="text-left font-serif text-lg font-semibold text-heritage-ink hover:text-heritage-terra hover:no-underline md:text-xl"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-answer-${i}`}
                                className="text-sm leading-relaxed text-heritage-ink/70 md:text-base"
                            >
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
);

export default Faq;
